import { Observable, firstValueFrom, from } from 'rxjs';

import { AppTypeEnum } from '../model/appType';
import { DexieService } from './dexieService';
import { HttpClient } from '@angular/common/http';
import { HttpUtils } from '../utils/httpUtils';
import { Injectable } from '@angular/core';
import { OnlineService } from './online.service';
import { User } from '../model/user';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable()
export class UsersService {

    constructor(
        private http: HttpClient,
        private dexieService: DexieService,
        private onlineService: OnlineService) {
    }

    findAllFromGroupAppType(idAppType: number): Observable<any> {
        if (this.onlineService.latestOnline) {
            const url = environment.coreUrl + `/users/appType/${idAppType}`;

            return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
        } else {
            return from(this.dexieService.responsablesGroup.toArray().timeout(30000));
        }
    }

    findAllRespFromGroup(): Observable<any> {
        if (this.onlineService.latestOnline) {
            const url = environment.coreUrl + '/users/responsables';

            return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
        } else {
            return from(this.dexieService.responsables.toArray().timeout(30000));
        }
    }

    findAllUserToSignFromGroup(): Observable<any> {
        const url = environment.coreUrl + '/users/usersToSign';

        return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

    async saveRespToDexie(): Promise<void> {
        const res = await firstValueFrom(this.findAllRespFromGroup());
        if (!res) return;

        await this.dexieService.responsables.clear();

        await Promise.all(res.map(data => this.dexieService.responsables.put(data)));
    
    }

    async saveRespFromGroupToDexie(): Promise<void> {
        const res = await firstValueFrom(this.findAllFromGroupAppType(AppTypeEnum.AIR));
        if (!res) return;

        await this.dexieService.responsablesGroup.clear();

        await Promise.all(res.map(data => this.dexieService.responsablesGroup.put(data)));
    }
}
